/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Skeleton } from '@coursera/cds-core';

import { learnerTableStyles } from 'bundles/enterprise-admin-messaging-v2/components/AIMessageModal/learnerTableStyles';

type Props = {
  /** Number of placeholder rows — match the page size so the table height is stable. */
  rowCount: number;
  /** Columns per row (2 for the viewer, 3 for the editor's action column). */
  columnCount: number;
};

/**
 * Shimmer rows shown while a page of learners is fetching. Rendering a full
 * page worth of rows keeps the table at its normal height, avoiding the layout
 * shift that a single "loading" line would cause between pages.
 */
const LearnerTableSkeletonRows = ({ rowCount, columnCount }: Props) => (
  <React.Fragment>
    {Array.from({ length: rowCount }).map((_, rowIndex) => (
      // eslint-disable-next-line react/no-array-index-key -- static placeholder rows, no identity
      <tr key={`learner-skeleton-${rowIndex}`} aria-hidden="true" data-testid="ai-message-modal-learner-skeleton-row">
        {Array.from({ length: columnCount }).map((__, columnIndex) => (
          // eslint-disable-next-line react/no-array-index-key -- static placeholder cells, no identity
          <td key={columnIndex} css={learnerTableStyles.td}>
            <Skeleton width="70%" />
          </td>
        ))}
      </tr>
    ))}
  </React.Fragment>
);

export default LearnerTableSkeletonRows;
